import { Injectable } from '@angular/core';
//languages
import * as es from '../../assets/i18n/es_MX.json';
import * as en from '../../assets/i18n/en_US.json';
//

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
    private allowedLanguages = {es,en};
    public getLanguage(lng: string){
        for(let i in this.allowedLanguages){
            if(i === lng){
                return this.allowedLanguages[i].default;
            }
        }
        return this.allowedLanguages.es.default;
    }
    public static getRequestLanguage(lng: string){
        const allowedLanguages = {es: 'es_MX',en:'en_US'};
        return typeof allowedLanguages[lng] !== 'undefined' ? allowedLanguages[lng] : allowedLanguages.es;
    }
}